module.exports = false;



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/_library.js
// module id = 33
// module chunks = 99